export default {
  getAviso: state => id => state.avisos.find(aviso => aviso.id === id),
}
